// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"da064273","113":"395221be","379":"422571e0","716":"c229f16a","787":"897ba8a3","808":"8ef0cdcb","953":"f6324857"}[chunkId] + ".chunk.js";
};